import { createRouter, createWebHistory } from "vue-router";
import Chart from "../Chart.vue";
import Welcome from "../components/Welcome.vue";
import Download from "../components/Download.vue";
import Dashboard from "../components/Dashboard.vue";
import Pricing from "../components/Pricing.vue";
import PaymentSuccess from "../components/PaymentSuccess.vue";
import PaymentFailure from "../components/PaymentFailure.vue";
import DemoChart from "../components/DemoChart.vue";
import IndicatorBuilder from "../components/indicator-builder/IndicatorBuilder.vue";
import {legacyStrategyLocation} from "../workspace/strategy/model.mjs";
import TradingCandleOptions from "../components/TradingCandleOptions.vue";
import TermsScreen from "../components/TermsScreen.vue";
import PrivacyPolicyScreen from "../components/PrivacyPolicyScreen.vue";
import Help from "../components/Help.vue";
import { authGuard, authOnlyGuard, adminGuard } from "../auth";



const demoGuard = (to, from, next) => {
  const demoCount = parseInt(localStorage.getItem('tc_demo_count') || '0', 10)
  if (demoCount <= 0) {
    // No demo attempts used via the button — redirect home
    return next({ path: '/' })
  }
  if (demoCount > 3) {
    // Exceeded max demos — redirect home (pricing requires auth)
    return next({ path: '/' })
  }
  next()
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/sign-in",
      component: () => import("../components/SignIn.vue"),
    },
    {
      path: "/sign-up",
      component: () => import("../components/SignIn.vue"),
    },
    {
      path: "/sso-callback",
      component: () => import("../components/SignIn.vue"),
    },
    {
      path: "/",
      name: "welcome",
      component: Welcome,
    },
    {
      path: "/download",
      name: "download",
      component: Download,
    },
    {
      path: "/demo",
      name: "demo",
      component: DemoChart,
      beforeEnter: demoGuard,
    },
    {
      path: "/dashboard",
      component: Dashboard,
      beforeEnter: authOnlyGuard,
      children: [
        { path: "", name: "dashboard", redirect: "/dashboard/overview" },
        { path: "overview", name: "dashboard-overview" },
        { path: "subscription", name: "dashboard-subscription" },
        { path: "payments", name: "dashboard-payments" },
        { path: "actions", name: "dashboard-actions" },
        { path: "brokers", name: "dashboard-brokers" },
      ],
    },
    {
      path: "/pricing",
      name: "pricing",
      component: Pricing,
    },
    {
      path: "/payment/success",
      name: "payment-success",
      component: PaymentSuccess,
      beforeEnter: authOnlyGuard,
    },
    {
      path: "/payment/failure",
      name: "payment-failure",
      component: PaymentFailure,
      beforeEnter: authOnlyGuard,
    },
    {
      path: "/chart",
      name: "chart",
      component: Chart,
      beforeEnter: (to,from,next) => (to.query.strategy || to.query.version || to.query.bot || ['strategies','build','results','automate','activity'].includes(to.query.tab) ? authOnlyGuard : authGuard)(to,from,next),
    },
    {
      path: "/indicator-builder",
      name: "indicator-builder",
      component: IndicatorBuilder,
      beforeEnter: authOnlyGuard,
    },
    {
      path: "/bots",
      name: "bots",
      component: () => import("../components/bots/BotWorkspace.vue"),
      beforeEnter: authOnlyGuard,
    },
    {
      path: "/strategy-builder",
      name: "strategy-builder",
      redirect: to => legacyStrategyLocation(to.query),
      beforeEnter: authOnlyGuard,
    },
    {
      path: "/options",
      name: "options",
      component: TradingCandleOptions,
      beforeEnter: authGuard,
    },
    {
      path: "/terms",
      name: "terms",
      component: TermsScreen,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: PrivacyPolicyScreen,
    },
    {
      path: "/help",
      name: "help",
      component: Help,
    },
    {
      path: "/help/:slug",
      name: "help-page",
      component: Help,
    },
    {
      path: "/admin",
      component: () => import("../components/admin/AdminPortal.vue"),
      beforeEnter: adminGuard,
      children: [
        {
          path: "",
          name: "admin-dashboard",
          component: () => import("../components/admin/AdminDashboard.vue"),
        },
        {
          path: "dashboard",
          name: "admin-dashboard-redirect",
          redirect: "/admin"
        },
        {
          path: "users",
          name: "admin-users",
          component: () => import("../components/admin/AdminUsers.vue"),
        },
        {
          path: "users/:id",
          name: "admin-user-detail",
          component: () => import("../components/admin/AdminUserDetail.vue"),
        },
        {
          path: "subscriptions",
          name: "admin-subscriptions",
          component: () => import("../components/admin/AdminSubscriptions.vue"),
        },
        {
          path: "payments",
          name: "admin-payments",
          component: () => import("../components/admin/AdminPayments.vue"),
        },
        {
          path: "credits",
          name: "admin-credits",
          component: () => import("../components/admin/AdminCredits.vue"),
        },
        {
          path: "integrations",
          name: "admin-integrations",
          component: () => import("../components/admin/AdminIntegrations.vue"),
        },
        {
          path: "logs",
          name: "admin-logs",
          component: () => import("../components/admin/AdminLogs.vue"),
        },
      ],
    },
  ],
});

router.afterEach((to) => {
  if (window.__TC_UPDATE_VIEWPORT) window.__TC_UPDATE_VIEWPORT(to.path);
});

export default router;
